export var CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
export var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
export var locationChangeAction = function locationChangeAction(location, action) {
  return {
    type: LOCATION_CHANGE,
    payload: {
      location: location,
      action: action
    }
  };
};
function updateLocation(method) {
  // @ts-ignore //support history 5.x back/forward
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return {
      type: CALL_HISTORY_METHOD,
      payload: {
        method: method,
        args: args
      }
    };
  };
}
export var push = updateLocation('push');
export var replace = updateLocation('replace');
export var go = updateLocation('go');
export var goBack = updateLocation('goBack');
export var goForward = updateLocation('goForward');
// @ts-ignore //support history 5.x back/forward
export var back = updateLocation('back');
// @ts-ignore //support history 5.x back/forward
export var forward = updateLocation('forward');